
import {initWebComponent} from "@/helpers/web-component-helper";
import {removeMeasure, startCesiumMeasure} from "@/modules/cesium/cesium-measure";
import {toggleAllowCameraUnderTerrain} from "@/modules/cesium/cesium";

const template = document.createElement('template');
template.innerHTML = `<label class="switcher mr-1">
    <input type="checkbox" class="switcher-input">
    <span class="switcher-indicator">
      <span class="switcher-yes">
        <span class="fa fa-draw-polygon"></span>
      </span>
      <span class="switcher-no">
        <span class="fa fa-times"></span>
      </span>
    </span>
    <span class="switcher-label">Afstand</span>
  </label>`;

export class CesiumMeasureButtonComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', (e) => {
            if(e.target.type === 'checkbox') {
                if (this.querySelector('input').checked) {
                    startCesiumMeasure()
                } else {
                    removeMeasure()
                }
            }
        })
    }
}

